import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { DashboardPersonnelService } from "../../core/service/dashboard-personnel.service";

import * as Highcharts from "highcharts";
import { ValeurDossierPortefeuilleDTO } from "../../core/model/valeur-dossier-portefeuille-dto";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { SuiviComponent } from "src/app/formulaire/modal/suivi/suivi.component";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { ReportingService } from "src/app/reporting/core/service/reporting.service";
import { DemandeResurmeDTO } from "src/app/suivi-portefeuille/core/model/resurme/demande-resurme-dto";
import { PageDemandeResurmeDTO } from "src/app/parametrage/core/model/page-demande-resurme-dto";
import { QuantiteDossierPortefeuilleDTO } from "../../core/model/quantite-dossier-portefeuille-dto";
import { QuantiteMontantWorkflowDTO } from "../../core/model/quantite_by_workflow/quantite-montant-workflow-dto";

@Component({
  selector: "app-mon-portefeuille",
  templateUrl: "./mon-portefeuille.component.html",
  styleUrls: ["./mon-portefeuille.component.scss"],
})
export class MonPortefeuilleComponent implements OnInit {
  debut: any = null;
  fin: any = null;
  username: String;
  highcharts = Highcharts;
  chartOptionsPourcentage: any;
  chartOptionsDossierCree: any;
  quantiteMontantWorkflowDTOs: QuantiteMontantWorkflowDTO[] = [];
  //
  pageDossierHistory: PageDemandeResurmeDTO;
  DossierHistory: DemandeResurmeDTO[];
  pageHistory: number = 1;
  totalElementsHistory: number = 0;
  filterHistory: String = "";
  state: String = "";
  workflow: String = "";
  
  maxSize = 5;
  //
  isLoadingResults = true;
  corporatePortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  particulierPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  professionnelPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  productProgramPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();

  updateFlagPourcentage : boolean = false;
  updateFlagDossierCree : boolean = false;

  constructor(
    private modalService: NgbModal,
    private _router: Router,
    private datePipe: DatePipe,
    private _requestService: RequestService,
    private _dashboardPersonnelService: DashboardPersonnelService,
    private _keycloakService: KeycloakService,
    private _reportingService: ReportingService
  ) {
    this.username = _keycloakService.getUsername();
  }

  ngOnInit() {
    this.pourcentageDossierByStatus(this.username);
    this.dossiersCreesSur12DerniersMois(this.username);
    this.valeurDossierPortefeuille(this.username);
    this.getRequestsHistoryByInitiateur(
      this.username,
      this.workflow,
      this.filterHistory,
      this.state,
      0,
      this.maxSize
    );
    //
    this.quantiteDossierPortefeuilleProfessionnel(this.username);
  }
  pourcentageDossierByStatus(username) {
    
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._dashboardPersonnelService
      .pourcentageDossierByStatus(username, deb, fn)
      .pipe(first())
      .subscribe(
        (response) => {
          const data = [];
          response.forEach(function (value) {
            data.push({ name: value.name, y: value.valeur });
          });


          this.chartOptionsPourcentage = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false,
            },
            title: {
              text: "Répartition des dossiers par statut",
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false,
                },

                showInLegend: true,
              },
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data,
              },
            ],
          };
          if(data.length > 0)
          {
            this.updateFlagPourcentage = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  
  dossiersCreesSur12DerniersMois(username) {
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";
    this._dashboardPersonnelService
      .dossiersCreesSur12DerniersMois(username, fn)
      .pipe(first())
      .subscribe(
        (response) => {
          const series = [];
          const categories = response.map((item) => item.name);
          const seriesData = response.map((item) => item.valeur);
          series.push({ name: "Créé", data: seriesData });

          this.chartOptionsDossierCree = {
            chart: {
              type: "column",
            },
            title: {
              text: "Dossiers créés sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: categories,
              crosshair: true,
            },
            yAxis: {
              min: 0,
              title: {
                text: "Quantité",
              },
            },
            tooltip: {
              headerFormat:
                '<span style = "font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
                '<td style = "padding:0"><b>{point.y:.1f} dossier(s)</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
            },
            series: series,
          };
          if(series.length > 0)
          {
            this.updateFlagDossierCree = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  valeurDossierPortefeuille(username) {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";
    this._dashboardPersonnelService
      .valeurDossierPortefeuille(username, deb, fn)
      .pipe(first())
      .subscribe(
        (response) => {
          this.quantiteMontantWorkflowDTOs = this.sortByWorkflow(response);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  dossierInfo(requestId, workflow) {
    if (workflow == "CORPORATE") {
      this._router.navigateByUrl("/cnce-corporate/dossier-info/" + requestId);
    } else if (workflow == "PARTICULIER") {
      this._router.navigateByUrl("/retail/dossier-info/" + requestId);
    } else if (workflow == "PROFESSIONNEL") {
      this._router.navigateByUrl(
        "/cnce-professionnel/dossier-info/" + requestId
      );
    }
  }

  refresh() {
    this.getRequestsHistoryByInitiateur(
      this.username,
      "_",
      this.filterHistory,
      this.state,
      0,
      this.maxSize
    );
    this.dossiersCreesSur12DerniersMois(this.username);
    this.valeurDossierPortefeuille(this.username);
    this.pourcentageDossierByStatus(this.username);
  }

  //
  getRequestsHistoryByInitiateur(
    username,
    workflow,
    filter,
    state,
    page,
    size
  ) {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this.isLoadingResults = true;
    this._requestService
      .getRequestsHistoryByInitiateur(
        workflow,
        filter,
        username,
        state,
        deb,
        fn,
        page,
        size
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.isLoadingResults = false;
          this.pageDossierHistory = data;
          this.DossierHistory = data.content;
          this.totalElementsHistory = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPageHistory(page: number): void {
    page = page - 1;
    this.getRequestsHistoryByInitiateur(
      this.username,
      this.workflow,
      this.filterHistory,
      this.state,
      page,
      this.maxSize
    );
  }

  filter(): void {
    this.getRequestsHistoryByInitiateur(
      this.username,
      this.workflow,
      this.filterHistory,
      this.state,
      0,
      this.maxSize
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterHistory = filterValue;
    this.getRequestsHistoryByInitiateur(
      this.username,
      this.workflow,
      this.filterHistory,
      this.state,
      0,
      this.maxSize
    );
  }

  exportRequestsHistoryByInitiateur() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportRequestsHistoryByInitiateur(
        this.workflow,
        this.filterHistory,
        this.username,
        this.state,
        deb,
        fn
      )
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "requests-history-" + deb + ".xlsx");
        document.body.appendChild(link);
        link.click();
      });
  }
  //

  Suivi(requestid) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestid;

    modalRef.result.then(
      (data) => {},
      (reason) => {}
    );
  }

  quantiteDossierPortefeuilleProfessionnel(username) {
    this._dashboardPersonnelService
      .quantiteDossierPortefeuilleByUsername("PROFESSIONNEL", username)
      .pipe(first())
      .subscribe(
        (data) => {
          this.professionnelPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getLibelle(status: string): string {
    switch (status) {
      case "ENCOURS":
        return "Dossiers en cours";
      case "MISEENPLACE":
        return "Dossiers mis en place";
      case "ENATTENTECOMPLEMENT":
        return "Dossiers en attente";
      case "APPROUVE":
        return "Dossiers approuvés";
      case "ABANDONNE":
        return "Dossiers abandonnés";
      case "REJETE":
        return "Dossiers rejetés";
      default:
        return "Autre statut";
    }
  }
  getCssClass(status: string): string {
    switch (status) {
      case "ENCOURS":
        return "mon-portefeuille-bg-indigo";
      case "MISEENPLACE":
        return "mon-portefeuille-bg-green";
      case "ENATTENTECOMPLEMENT":
        return "mon-portefeuille-bg-green";
      case "APPROUVE":
        return "mon-portefeuille-bg-green";
      case "ABANDONNE":
        return "mon-portefeuille-bg-red";
      case "REJETE":
        return "mon-portefeuille-bg-blue";
      default:
        return "";
    }
  }
  sortByWorkflow(dossiers: any[]): any[] {
    return dossiers.sort((a, b) => {
      if (a.workflow < b.workflow) {
        return -1;
      } else if (a.workflow > b.workflow) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}
